import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {HttpClient,HttpHeaders} from "@angular/common/http";

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  private APIURL = environment.baseURL;

  constructor(public httpClient: HttpClient,private authService:AuthService) { this.httpClient = httpClient; }

  pendingSubscription(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/subscription/pending`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  detailSubscription(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/subscription/pending/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getCurrentSubscription(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/subscription/user/${JSON.parse(localStorage.getItem("me")).user.id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  reload(){
    return this.httpClient.get(`${this.APIURL}/reload/${JSON.parse(localStorage.getItem("me")).user.id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  view_doc(i): Observable<any> {
    return this.httpClient.get(`${environment.mainURL}/receipt/pdf?subscriptionId=`+i, { responseType: 'arraybuffer' 
    })
  }

  getSubscriptionHistory(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/subscription/user/history/${JSON.parse(localStorage.getItem("me")).user.id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  payment(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/subscription/payment`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  renew(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/subscription/renew`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  // package

  add_package(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/package`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  update_package(param,id): Observable<any> {
    return this.httpClient.put(`${this.APIURL}/package/${id}`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  delete_package(id): Observable<any> {
    return this.httpClient.delete(`${this.APIURL}/package/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  get_package_detail(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/package/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  private handleError(error: any): Observable<any> {
    return throwError(error);
  }
}
